// extracted by mini-css-extract-plugin
export default {"card":"e7-z"};